// ui/src/hooks/useHandlebarsTemplate.js
import { useEffect, useRef, useState } from "react";
import * as Handlebars from "handlebars";
import apiAction from "../../../ajax/service";

export function useHandlebarsTemplate(url = "/api/template/invoice") {
  const compiledRef = useRef(null);
  const [status, setStatus] = useState("idle");

  useEffect(() => {

    (async () => {
      try {
        setStatus("loading");
        const templateStr = await apiAction("raw",{url:url,method:'GET'},'get')


        const compiled = Handlebars.compile(templateStr, { noEscape: true });

          compiledRef.current = compiled;
          setStatus("ready");

      } catch (err) {
        console.error(err);
        setStatus("error");
      }
    })();

  }, [url]);

  return { render: compiledRef.current, status };
}
